import { createRouter, createWebHistory } from "vue-router";
import { getUserToken } from "@/store/session.js";
const routes = [

    {
        path: '',
        redirect: 'chat',
        meta: { title: 'Construction-GPT' },
        component: () => import('@/views/ChatPlus.vue'),
    },
    {
        name: 'home',
        path: '/home',
        meta: { title: 'Construction-GPT' },
        component: () => import('@/views/Home.vue'),
    },
    {
        name: 'login',
        path: '/login',
        meta: { title: 'Construction-GPT' },
        component: () => import('@/views/Login.vue'),
    },
    {
        name: 'chat',
        path: '/chat',
        meta: { title: 'Construction-GPT' },
        component: () => import('@/views/ChatPlus.vue'),
    },
    {
        name: 'chat-id',
        path: '/chat/:id',
        meta: { title: 'Construction-GPT' },
        component: () => import('@/views/ChatPlus.vue'),
        props: true // 将路由参数传递给组件的 props
    },
    // {
    //     name: 'pay',
    //     path: '/pay',
    //     meta: { title: 'Construction-GPT' },
    //     component: () => import('@/views/pay/index.vue'),
    // },
    {
        name: 'pdf',
        path: '/pdf',
        meta: { title: 'pdf' },
        component: () => import('@/views/Pdf.vue'),
    },
    {
        name: 'NotFound',
        path: '/:all(.*)',
        meta: { title: 'Construction-GPT' },
        component: () => import('@/views/404.vue'),
    },

]

// console.log(MY_VARIABLE)
const router = createRouter({
    history: createWebHistory(),
    routes: routes,
})

// dynamic change the title when router change
router.beforeEach((to, from, next) => {
    if (to.path == '/chat' || to.path == '/home') return next()
    if (!getUserToken()) return next('/chat')
    if (to.meta.title) {
        document.title = `${to.meta.title}`
    }
    next()

})

export default router;